import { PreferencesContext } from "../../contexts/PreferencesContext";
import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { withRouter, Redirect, Link } from 'react-router-dom';
import { logout } from '../../actions/AppActions';
import { connect } from 'react-redux';

// users
import moment from 'moment';
import { API_URL, STORAGE_URL, URL } from '../../variables';
import { maskNumber } from '../../Auxiliar/Masks';

import ReactPaginate from 'react-paginate';
import { MdReply } from 'react-icons/md';
import { Form, FormControl as Input, InputGroup, Button, Select, Spinner } from "react-bootstrap";
import ImageLoaderInput from '../ReusableComponents/ImageLoaderInput';
import Attention from '../ReusableComponents/Attention';
import { RiArrowGoBackLine } from 'react-icons/ri';
import DefaultButton from '../ReusableComponents/DefaultButton';
import JoditEditor from 'jodit-react';
import ProcessoConfigSummary from './ProcessoConfigSummary';
import {
    chatOptionKeys,
    imageIntervalOptionKeys,
    proctoringOptionKeys,
    simulationProctoringOptionKeys,
    translateOption
} from './processoTranslationOptions';


import './label.css';
import { DatePicker, TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import 'moment/locale/pt-br';
import { alpha } from '@material-ui/core/styles';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import { RadioGroup } from '@mui/material';

class EditarProcesso extends Component {
    static contextType = PreferencesContext;

    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            path: '/',
            loading_screen: true,
            roles: [],
            name: '',
            regras: '',
            descricao: '',
            code: '',
            fim: moment().add(1, 'day'),
            hora_inicio: moment(),
            hora_fim: moment().add(1, 'hour'),

            loading_save: false,
            msgErro: '',
            loading_image: false,
            inicio: moment(),
            faculdade: { name: '', id: '' },
            fiscalizacoes: [
                { id: 'all', 'name': 'Salvar Vídeo e Imagem - Com streaming em tempo real' },
                { id: 'image', 'name': 'Salvar Apenas Imagem - Com streaming em tempo real' },
                { id: 'none', 'name': 'Salvar apenas logs - Sem streaming' }],

            fiscalizacoes_simulado: [
                { id: 'all', 'name': 'Testar compartilhamento de câmera e áudio' },
                { id: 'none', 'name': 'Não compartilhar câmera e áudio' }],

            fiscalizacao: 'all',

            chat_types: [
                { id: 'all', 'name': 'Ambos enviam mensagem' },
                { id: 'fiscal_to_student', 'name': 'Apenas o fiscal envia mensagem' },
                { id: 'none', 'name': 'Ninguem envia mensagem' }],

            chat_type: 'all',

            times_save: [
                { id: '30000', 'name': '30 segundos' },
                { id: '15000', 'name': '15 segundos' }],

            time_save: '30000',
            tempo_prova: '',
            type_time: 'all',
            online: true,
            full_screen: true,
            screen_extended_retrict: true,
            screen_sharing: false,
            required_external_camera: false,
            recording_start_before_enabled: false,
            recording_start_before_minutes: 5,
            mobile: false,
            time_validation_periodicaly: 40,
            chat_time: 60,
            request_time: 60,
            exam_per_time: false,
            restrict_access: false,
            face_validation: false,
            show_document: false,
            face_validation_periodicaly: false,
            is_interview: false,
            inicio_access: moment().subtract('hour', 24),
            fim_access: moment(),
            hora_inicio_access: moment().subtract('hour', 24),
            hora_fim_access: moment(),
            simulado: false,
            show_rascunho: true,
            need_pause: false,
            has_blocks: false

        };

        this.config = {
            height: 300,
            // askBeforePasteHTML:false,
            // askBeforePasteFromWord:false,
            // defaultActionOnPaste:'insert_only_text',
            // defaultActionOnPasteFromWord:'insert_only_text',
            // pasteHTMLActionList:[
            //     { value: 'insert_only_text', text: 'Insert only Text' }
            // ],
            // pasteFromWordActionList:[
            //     { value: 'insert_only_text', text: 'Insert only Text' }
            // ],
            readonly: this.state.loading_image,
            language: 'pt_br',
            toolbarButtonSize: 'large',
            "buttons": "source,bold,italic,underline,strikethrough,eraser,superscript,subscript,ul,ol,indent,outdent,left,center,right,justify,font,fontsize,paragraph,classSpan,image,brush,,undo,redo,hr,link,symbol,table",
            uploader: {
                url: API_URL + 'faculdade/upload_image', //your upload api url
                insertImageAsBase64URI: false, //not inster base64
                imagesExtensions: ['jpg', 'png', 'jpeg', 'gif'],
                headers: { "accept": `application/json`, 'Authorization': 'Bearer ' + localStorage.getItem('token') },
                filesVariableName: function (t) {
                    return 'imagem';
                }, //"files",
                withCredentials: false,
                pathVariableName: 'path',
                //   format: 'json',
                method: 'POST',
                prepareData: (formdata) => {
                    console.log(formdata);
                    this.setState({ loading_image: true });
                    return formdata;
                },
                isSuccess: (e) => {
                    console.log(e);

                    return 'Upload realizado com sucesso';
                },
                getMessage: (e) => {
                    console.log(e);

                    return e;
                },
                process: (resp) => {//success callback transfrom data to defaultHandlerSuccess use.it's up to you.
                    let files = [];
                    console.log(resp);
                    files.unshift(STORAGE_URL + resp.imagem);
                    this.setState({ loading_image: false });

                    return {
                        files: files

                    };
                },
                error: (elem, e) => {
                    // elem.j.e.fire('errorMessage', e.message, 'error', 4000);

                    console.log(e);
                    console.log(elem);
                    console.log('Bearer ' + localStorage.getItem('token'));
                },
                defaultHandlerSuccess: function (resp, elem) {// `this` is the editor.
                    if (resp.files && resp.files.length) {
                        resp.files.forEach((filename, index) => {//edetor insertimg function
                            this.selection.insertImage(filename);
                        });
                    }

                    // debugger;

                },
                defaultHandlerError: (elem, e) => {
                    // elem.j.e.fire('errorMessage', e.message);
                    console.log(e);
                    console.log(elem);
                    this.setState({ loading_image: false });

                }
                //   contentType: function (e) {
                //     return (

                //       'application/x-www-form-urlencoded; charset=UTF-8'
                //     );
                //   },
            }
        };
    }

    get_processo(id) {

        if (this.state.loading_screen == false) {
            this.setState({ loading_screen: true });
        }
        fetch(`${URL}api/faculdade/get_processo/${id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Authorization': `Bearer ${this.props.token}`
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token'); localStorage.removeItem('user');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n'; else

                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ redirect: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                } else {
                    // this.props.mudarUser(resp.user);
                    this.setState({
                        loading_screen: false, faculdade: resp.processo.faculdade,
                        name: resp.processo.name,
                        code: resp.processo.code ?? '',

                        inicio: moment(resp.processo.inicio),
                        fim: moment(resp.processo.fim),
                        hora_inicio: moment(resp.processo.inicio),
                        hora_fim: moment(resp.processo.fim),
                        regras: resp.processo.regras,
                        descricao: resp.processo.descricao,
                        online: resp.processo.online,
                        need_pause: resp.processo.need_pause,
                        has_blocks: resp.processo.simulado ? false : resp.processo.has_blocks,
                        request_time: resp.processo.request_time / 60,
                        chat_time: resp.processo.chat_time / 60,
                        time_validation_periodicaly: resp.processo.time_validation_periodicaly,

                        restrict_access: resp.processo.restrict_access,
                        inicio_access: resp.processo.time_init_restrict == null ? this.state.inicio_access : moment(resp.processo.time_init_restrict),
                        hora_inicio_access: resp.processo.time_init_restrict == null ? this.state.hora_inicio_access : moment(resp.processo.time_init_restrict),

                        fim_access: resp.processo.time_end_restrict == null ? this.state.fim_access : moment(resp.processo.time_end_restrict),
                        hora_fim_access: resp.processo.time_end_restrict == null ? this.state.hora_fim_access : moment(resp.processo.time_end_restrict),


                        simulado: resp.processo.simulado,
                        exam_per_time: resp.processo.exam_per_time,
                        mobile: resp.processo.mobile,

                        show_rascunho: resp.processo.show_rascunho,
                        chat_type: resp.processo.chat_type,
                        time_save: resp.processo.save_timer,
                        fiscalizacao: resp.processo.type_fiscalization,
                        type_time: resp.processo.simulado ? 'restrict' : resp.processo.has_blocks ? 'all' : resp.processo.type_time,
                        screen_extended_retrict: resp.processo.screen_extended_retrict,
                        screen_sharing: resp.processo.screen_sharing,
                        required_external_camera: resp.processo.type_fiscalization != 'all' || resp.processo.mobile ? false : resp.processo.required_external_camera === true,
                        recording_start_before_enabled: resp.processo.simulado || resp.processo.type_fiscalization != 'all' ? false : parseInt(resp.processo.recording_start_before_minutes || 0, 10) > 0,
                        recording_start_before_minutes: resp.processo.simulado || resp.processo.type_fiscalization != 'all' || parseInt(resp.processo.recording_start_before_minutes || 0, 10) <= 0 ? 5 : Math.min(30, Math.max(1, parseInt(resp.processo.recording_start_before_minutes || 5, 10) || 5)),
                        face_validation: resp.processo.face_validation,
                        show_document: resp.processo.show_document === true,
                        face_validation_periodicaly: resp.processo.face_validation_periodicaly,

                        is_interview: resp.processo.is_interview,
                        full_screen: resp.processo.full_screen,

                        tempo_prova: resp.processo.simulado ? '4' : resp.processo.has_blocks || resp.processo.tempo_prova == null ? '' : resp.processo.tempo_prova + ''
                    });
                    // if (resp.processo != null) {


                }




            } catch (err) {
                this.setState({ redirect: true });
                console.log(err);


            }

        }).
            catch((err) => {
                this.setState({ redirect: true });

                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }



    salvar(e) {
        e.preventDefault();
        if (this.state.restrict_access == true && this.state.inicio_access.format('YYYY-MM-DD') + ' ' + this.state.hora_inicio_access.format('HH:mm') > this.state.inicio.format('YYYY-MM-DD') + ' ' + this.state.hora_inicio.format('HH:mm')) {
            this.setState({ msgErro: this.context.t("error_exam_start_after_access_start") });
            window.scrollTo(500, 0);

            return;
        }
        if (this.state.restrict_access == true && this.state.fim_access.format('YYYY-MM-DD') + ' ' + this.state.hora_fim_access.format('HH:mm') >= this.state.fim.format('YYYY-MM-DD') + ' ' + this.state.hora_fim.format('HH:mm')) {
            this.setState({ msgErro: this.context.t("error_exam_end_after_access_end") });
            window.scrollTo(500, 0);

            return;
        }

        this.setState({ loading_save: true, msgErro: '' });


        let data = {
            name: this.state.name,
            descricao: this.state.descricao,
            code: this.state.code,

            regras: this.state.regras,
            hora_inicio: this.state.hora_inicio.format('HH:mm'),
            inicio: this.state.inicio.format('DD/MM/YYYY'),
            fim: this.state.fim.format('DD/MM/YYYY'),
            hora_fim: this.state.hora_fim.format('HH:mm'),

            hora_inicio_access: this.state.hora_inicio_access.format('HH:mm'),
            inicio_access: this.state.inicio_access.format('DD/MM/YYYY'),
            fim_access: this.state.fim_access.format('DD/MM/YYYY'),
            hora_fim_access: this.state.hora_fim_access.format('HH:mm'),

            chat_time: this.state.chat_time != '' ? this.state.chat_time * 60 : this.state.fiscalizacao != 'none' ? '' : 3600,
            request_time: this.state.request_time != '' ? this.state.request_time * 60 : this.state.face_validation ? '' : 3600,
            time_validation_periodicaly: this.state.time_validation_periodicaly != '' ? this.state.time_validation_periodicaly : this.state.face_validation_periodicaly ? '' : 40,

            fiscalizacao: this.state.fiscalizacao,
            chat_type: this.state.chat_type,

            processo_id: this.props.match.params.id,
            type_time: this.state.simulado == true ? 'restrict' : this.state.has_blocks == true ? 'all' : this.state.type_time,
            tempo_prova: this.state.simulado == true ? 4 : this.state.has_blocks == true ? '' : this.state.tempo_prova,
            online: this.state.online,
            full_screen: this.state.full_screen,
            screen_extended_retrict: this.state.screen_sharing == true ? true : this.state.screen_extended_retrict,
            screen_sharing: this.state.screen_sharing,
            required_external_camera: this.state.fiscalizacao == 'all' && this.state.mobile == false ? this.state.required_external_camera : false,
            recording_start_before_minutes: this.state.simulado == false && this.state.fiscalizacao == 'all' && this.state.mobile == false && this.state.recording_start_before_enabled == true ? Math.min(30, Math.max(1, parseInt(this.state.recording_start_before_minutes || 5, 10) || 5)) : 0,
            face_validation: this.state.face_validation,
            show_document: this.state.show_document,
            face_validation_periodicaly: this.state.face_validation_periodicaly,
            has_blocks: this.state.simulado == true ? false : this.state.has_blocks,

            hora_inicio_access: this.state.hora_inicio_access.format('HH:mm'),
            inicio_access: this.state.inicio_access.format('DD/MM/YYYY'),
            fim_access: this.state.fim_access.format('DD/MM/YYYY'),
            hora_fim_access: this.state.hora_fim_access.format('HH:mm'),

            restrict_access: this.state.restrict_access,
            simulado: this.state.simulado==true?true:false,
            show_rascunho: this.state.show_rascunho,
            mobile: this.state.mobile,
            need_pause: this.state.need_pause
            // exam_per_time: this.state.exam_per_time,
        };




        fetch(`${URL}api/faculdade/update_processo`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-type': 'application/json',

                'Authorization': `Bearer ${this.props.token}`
            },
            body: JSON.stringify(data)
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n'; else

                            erro += errors[i];
                    }
                    console.log(erro);
                    window.scrollTo(500, 0);

                    this.setState({ loading_save: false, msgErro: erro });
                } else {

                    this.setState({ loading_save: false, redirect: true });

                }




            } catch (err) {
                console.log(err);
                this.setState({ loading_save: false, msgErro: this.context.t("error_fetch_server_response_short") });

            }

        }).
            catch((err) => {
                console.log(err);
                this.setState({ loading_save: false, msgErro: this.context.t("error_server_connection") });
            });
    }


    componentDidMount() {
        this.get_processo(this.props.match.params.id);
    }



    componentWillUnmount() {
        Array.from(document.getElementsByClassName('jodit-wysiwyg')).forEach((el) => {
            // Do stuff here
            el.blur();
        });
    }

    change_tipo(event) {
        this.setState({ tipo: event.target.value });
    }


    render() {
        return (
            <div className="row">
                {this.state.redirect == true && <Redirect to={`/instituicao/show/${this.state.faculdade.id}`} />}

                <div className="col-12 col-xl-8">
                    <div className="card">
                        <div className="card-body" id="card">


                            <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>{`${this.context.t("edit")} ${this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("process") : this.context.t("vacancy")}`}</h4>
                            <p style={{ fontSize: '1rem', color: 'black' }}>Edite um processo seletivo {this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_da_instituicao") : this.context.t("legacy_do_processo")} {this.state.faculdade.name}</p>
                            <br />

                            {/* <hr /> */}
                            {this.state.loading_screen == false && <div>
                                {this.state.msgErro != '' && <div style={{ display: 'flex', marginBottom: 15, width: '100%' }}>
                                    <div className="badge badge-danger error-message-badge error-message-badge-dismissible w-100" role="alert">
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => this.setState({ msgErro: '' })}></button>


                                        <p style={{ marginBottom: 0 }}>{this.state.msgErro}</p>

                                    </div>
                                    <br />

                                </div>}
                                <Form onSubmit={(e) => this.salvar(e)} style={{ position: "relative" }}>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_name")} `}<Attention /></Form.Label>
                                            <Input
                                                placeholder={`${this.context.t("label_name")} ${this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_do_processo") : this.context.t("label_of_vacancy_position")}`}
                                                value={this.state.name}
                                                onChange={(e) => this.setState({ name: e.target.value })}
                                                required
                                            // title="Coloque o nome completo do usuário"
                                            />
                                        </div>
                                    </InputGroup>

                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_description")} `}<Attention /></Form.Label>
                                            <Input
                                                placeholder={`${this.context.t("label_description")} ${this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_do_processo") : this.context.t("label_of_vacancy_position")}`}
                                                value={this.state.descricao}
                                                onChange={(e) => this.setState({ descricao: e.target.value })}
                                                required
                                                as="textarea" />

                                        </div>
                                    </InputGroup>
                                    <InputGroup>

                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{`${this.context.t("label_rules")} `}{this.props.user.empresa == null || this.props.user.empresa.change_text == false ? this.context.t("legacy_do_processo") : this.context.t("label_of_vacancy_position")} <Attention /> {this.state.loading_image == true && <div className="spinner-border text-primary spinner-border-sm" role="status">
                                            </div>}</Form.Label>
                                            <JoditEditor
                                                ref={this.editor}
                                                value={this.state.regras}
                                                config={this.config}
                                                height={400}
                                                tabIndex={1} // tabIndex of textarea
                                                onBlur={(newContent) => this.setState({ regras: newContent })} // preferred to use only this option to update the content for performance reasons
                                            // onChange={newContent => {this.setState({enunciado:newContent}) }}
                                            />
                                        </div>
                                    </InputGroup>

                                    {this.props.user?.empresa?.online_proccess == true && <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_a_avaliacao_e_online_63f6668d")}<Attention /></Form.Label>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={this.state.online}
                                                onChange={(e) => {
                                                    this.setState({ online: e.target.value });
                                                }}>

                                                <FormControlLabel onClick={(e) => {
                                                    this.setState({ online: true });
                                                }} control={<Radio checked={this.state.online == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={(e) => {
                                                    console.log(e.target.value);
                                                    this.setState({ online: false });

                                                }} control={<Radio checked={this.state.online == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>
                                    </InputGroup>}

                                    {this.props.user?.empresa?.online_proccess == true && this.state.online == true && <InputGroup>
                                        <div className="flex fdcolumn flex1 margin-bottom">
                                            <Form.Label>{this.context.t("ui_e_um_avaliacao_oral_031e9629")}<Attention /></Form.Label>
                                            <small>{this.context.t("ui_se_habilitado_esta_vaga_cargo_sera_uma_entrevista__b2e828a7")}</small>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={this.state.is_interview}
                                                disabled
                                                onChange={(e) => {
                                                }}>

                                                <FormControlLabel disabled onClick={(e) => {
                                                }} control={<Radio checked={this.state.is_interview == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                <FormControlLabel onClick={(e) => {
                                                    console.log(e.target.value);

                                                }} disabled control={<Radio checked={this.state.is_interview == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                            </RadioGroup>
                                        </div>
                                    </InputGroup>}


                                    <MuiPickersUtilsProvider utils={MomentUtils}>

                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                <Form.Label>{`${this.context.t("legacy_data_de_inicio")} `}<Attention /></Form.Label>
                                                <DatePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage={this.context.t("ui_data_invalida_76fc5825")}
                                                    ampm={false}
                                                    minDate={moment()}
                                                    id="time-picker"
                                                    cancelLabel={this.context.t("legacy_cancelar")}
                                                    clearLabel={this.context.t("action_clear")}
                                                    format="DD/MM/YYYY"
                                                    value={this.state.inicio}
                                                    onChange={(date) => { this.setState({ inicio: date }); }} />


                                            </div>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_horario_de_inicio_701ca30c")}<Attention /></Form.Label>
                                                <TimePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage={this.context.t("ui_horario_invalido_6d7a8390")}
                                                    ampm={false}
                                                    id="time-picker"
                                                    cancelLabel={this.context.t("legacy_cancelar")}
                                                    clearLabel={this.context.t("action_clear")}
                                                    label=""
                                                    value={this.state.hora_inicio}
                                                    onChange={(date) => { this.setState({ hora_inicio: date }); }} />


                                            </div>
                                        </InputGroup>

                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                <Form.Label>{`${this.context.t("legacy_data_de_encerramento")} `}<Attention /></Form.Label>
                                                <DatePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage={this.context.t("ui_data_invalida_76fc5825")}
                                                    ampm={false}
                                                    minDate={moment()}
                                                    id="time-picker"
                                                    cancelLabel={this.context.t("legacy_cancelar")}
                                                    clearLabel={this.context.t("action_clear")}
                                                    format="DD/MM/YYYY"
                                                    value={this.state.fim}
                                                    onChange={(date) => { this.setState({ fim: date }); }} />


                                            </div>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{`${this.context.t("label_end_time")} `}<Attention /></Form.Label>
                                                <TimePicker
                                                    autoOk
                                                    margin="normal"
                                                    style={{ width: '100%' }}
                                                    invalidDateMessage={this.context.t("ui_horario_invalido_6d7a8390")}
                                                    ampm={false}
                                                    id="time-picker"
                                                    cancelLabel={this.context.t("legacy_cancelar")}
                                                    clearLabel={this.context.t("action_clear")}
                                                    label=""
                                                    value={this.state.hora_fim}
                                                    onChange={(date) => { this.setState({ hora_fim: date }); }} />


                                            </div>
                                        </InputGroup>


                                    </MuiPickersUtilsProvider>
                                    {this.state.online == true && <>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_e_um_simulado_para_teste_de_compatibilidade_dos_ca_be36cb46")}<Attention /></Form.Label>
                                                <small>{this.context.t("ui_se_habilitado_essa_vaga_cargo_sera_um_teste_para_o_6222b09d")}</small>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.simulado}
                                                    disabled
                                                    onChange={(e) => {
                                                        let data = {};
                                                        if (e.target.value == true) {
                                                            data.type_time = 'restrict';
                                                            data.tempo_prova = 4;
                                                            data.fiscalizacao = 'all';
                                                            data.chat_type = 'none';
                                                            data.exam_per_time = false;

                                                        } else {
                                                            data.chat_type = 'all';
                                                            data.type_time = 'all';
                                                            data.tempo_prova = '';
                                                        }
                                                        return;
                                                        this.setState({ simulado: e.target.value, ...data });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        let data = {};
                                                        data.type_time = 'restrict';
                                                        data.tempo_prova = 4;
                                                        data.fiscalizacao = 'all';
                                                        data.chat_type = 'none';
                                                        data.exam_per_time = false;
                                                        return;

                                                        this.setState({ simulado: true, ...data });
                                                    }} disabled control={<Radio checked={this.state.simulado == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        let data = {};
                                                        data.chat_type = 'all';
                                                        data.type_time = 'all';
                                                        data.tempo_prova = '';
                                                        return;

                                                        this.setState({ simulado: false, ...data });

                                                    }} disabled control={<Radio checked={this.state.simulado == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_cada_avaliacao_tera_um_tempo_maximo_para_fazer_e0de075c")}<Attention /></Form.Label>
                                                <small>{this.context.t("ui_se_habilitado_na_hora_de_criar_a_prova_sera_obriga_8f8b7f7f")}</small>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.exam_per_time}
                                                    onChange={(e) => {
                                                        if (this.state.simulado == true) {
                                                            return;
                                                        }
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        if (this.state.simulado == true) {
                                                            return;
                                                        }
                                                    }} disabled control={<Radio checked={this.state.exam_per_time == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        if (this.state.simulado == true) {
                                                            return;
                                                        }

                                                    }} disabled control={<Radio checked={this.state.exam_per_time == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_o_candidato_podera_solicitar_pausa_durante_a_prova_6d5871fc")}<Attention /></Form.Label>
                                                <small>{this.context.t("ui_se_habilitado_e_exibilido_um_botao_de_pedir_pausa__a63c10d6")}</small>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.need_pause}
                                                    onChange={(e) => {

                                                        this.setState({ need_pause: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {

                                                        this.setState({ need_pause: true });
                                                    }} control={<Radio checked={this.state.need_pause == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {

                                                        this.setState({ need_pause: false });

                                                    }} control={<Radio checked={this.state.need_pause == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>
                                            </div>
                                        </InputGroup>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_o_candidato_podera_acessar_por_dispositivos_moveis_f529a234")}<Attention /></Form.Label>
                                                <small>{this.context.t("ui_se_habilitado_a_avaliacao_tambem_podera_ser_realiz_ccf181b9")}</small>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.mobile}
                                                    onChange={(e) => {




                                                        // this.setState({ mobile: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        let data = {}; data.screen_sharing = false; data.required_external_camera = false; data.face_validation = false; data.show_document = false;
                                                        data.face_validation_periodicaly = false;

                                                        this.setState({ mobile: true, ...data });
                                                    }} control={<Radio checked={this.state.mobile == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ mobile: false });

                                                    }} control={<Radio checked={this.state.mobile == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>
                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_disponibilizar_campo_para_rascunho_em_cada_questao_59890895")}<Attention /></Form.Label>
                                                <small>{this.context.t("ui_se_habilitado_em_cada_questao_tera_um_botao_de_ras_29b1be64")}</small>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.show_rascunho}
                                                    onChange={(e) => {
                                                        this.setState({ show_rascunho: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ show_rascunho: true });
                                                    }} control={<Radio checked={this.state.show_rascunho == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ show_rascunho: false });

                                                    }} control={<Radio checked={this.state.show_rascunho == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>

                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_obrigar_o_uso_de_tela_cheia_para_ver_a_avaliacao_81575207")}<Attention /></Form.Label>
                                                <small>{this.context.t("ui_se_habilitado_o_candidato_so_conseguira_fazer_a_av_c5c6d2f3")}</small>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.full_screen}
                                                    onChange={(e) => {
                                                        this.setState({ full_screen: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ full_screen: true });
                                                    }} control={<Radio checked={this.state.full_screen == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ full_screen: false });

                                                    }} control={<Radio checked={this.state.full_screen == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>
                                        <InputGroup>

                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("form_exam_time")} <Attention /></Form.Label>

                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.type_time}
                                                    disabled={this.state.simulado || this.state.has_blocks}

                                                    onChange={(e) => {
                                                        if (this.state.simulado || this.state.has_blocks) {
                                                            return;
                                                        }
                                                        this.setState({ type_time: e.target.value });
                                                    }}>

                                                    <FormControlLabel
                                                        disabled={this.state.simulado || this.state.has_blocks}

                                                        onClick={(e) => {
                                                            if (this.state.simulado || this.state.has_blocks) {
                                                                return;
                                                            }
                                                            this.setState({ type_time: 'all' });
                                                    }} control={<Radio checked={this.state.type_time == 'all'} value={'all'} />} style={{ color: 'black' }} label={this.context.t("form_candidate_total_time")} />
                                                    <FormControlLabel
                                                        disabled={this.state.simulado || this.state.has_blocks}

                                                        onClick={(e) => {
                                                            if (this.state.simulado || this.state.has_blocks) {
                                                                return;
                                                            }
                                                            this.setState({ type_time: 'restrict' });

                                                    }} control={<Radio checked={this.state.type_time == 'restrict'} value={'restrict'} />} style={{ color: 'black' }} label={this.context.t("form_candidate_restricted_time")} />

                                                </RadioGroup>

                                                {this.state.type_time == 'restrict' && !this.state.has_blocks && <>
                                                    <Form.Label>{this.context.t("form_exam_time_minutes")} <Attention /></Form.Label>
                                                    <Input
                                                        disabled={this.state.simulado || this.state.has_blocks}
                                                        min={1}

                                                        placeholder={this.context.t("ui_tempo_de_prova_em_minutos_que_o_candidato_tera_apo_f25d6411")}
                                                        value={this.state.tempo_prova}
                                                        onChange={(e) => this.setState({ tempo_prova: e.target.value })}
                                                        required
                                                        type='number'
                                                    // title="Coloque o nome completo do usuário"
                                                    />
                                                </>}


                                            </div>


                                        </InputGroup>
                                        {this.state.simulado == false && <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{`${this.context.t("label_proctoring_type")} `}<Attention /></Form.Label>
                                                <select disabled className="form-select " onChange={(e) => {














































                                                    let chat_type = this.state.chat_type;
                                                    let time_save = this.state.time_save;
                                                    if (e.target.value == 'all') {
                                                        chat_type = 'all';
                                                        time_save = '30000';
                                                    }
                                                    else if (e.target.value == 'none') {
                                                        chat_type = 'all';
                                                        time_save = '30000';
                                                    }
                                                    this.setState({ fiscalizacao: e.target.value, chat_type, time_save, face_validation: false, face_validation_periodicaly: false, screen_sharing: false, required_external_camera: false, recording_start_before_enabled: false, recording_start_before_minutes: 5 });
                                                }} value={this.state.fiscalizacao}>
                                                    {this.state.simulado == false && this.state.fiscalizacoes && this.state.fiscalizacoes.length != 0 && this.state.fiscalizacoes.map((value, index) => <option key={index} value={value["id"]}>{translateOption(this.context.t, proctoringOptionKeys, value)}</option>)}
                                                    {this.state.simulado == true && this.state.fiscalizacoes_simulado && this.state.fiscalizacoes_simulado.length != 0 && this.state.fiscalizacoes_simulado.map((value, index) => <option key={index} value={value["id"]}>{translateOption(this.context.t, simulationProctoringOptionKeys, value)}</option>)}
                                                </select>
                                            </div>

                                        </InputGroup>}
                                        {this.state.fiscalizacao == 'image' && <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("form_chat_type")} <Attention /></Form.Label>
                                                <select disabled className="form-select " onChange={(e) => { this.setState({ chat_type: e.target.value }); }} value={this.state.chat_type}>
                                                    {this.state.chat_types && this.state.chat_types.length != 0 && this.state.chat_types.map((value, index) => <option key={index} value={value["id"]}>
                                                        {translateOption(this.context.t, chatOptionKeys, value)}</option>)}
                                                </select>
                                            </div>
                                        </InputGroup>}

                                        {this.state.fiscalizacao != 'none' && <InputGroup>
                                            <div className="margin-bottom">
                                                <>
                                                    <Form.Label>{this.context.t("ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_6be44aeb")}<Attention /></Form.Label>
                                                    <br />

                                                    <small>{this.context.t("ui_exemplo_caso_seja_colocado_60_minutos_entao_uma_ho_3f08b307")}</small>

                                                    <Input placeholder={this.context.t("ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_6be44aeb")} value={this.state.chat_time} min={1} onChange={(e) => this.setState({ chat_time: e.target.value })} required type='number' // title="Coloque o nome completo do usuário"
                                                    />
                                                </>
                                            </div></InputGroup>}

                                        {/* {this.state.fiscalizacao == 'image' && <InputGroup>
                      <div className="flex fdcolumn flex1 margin-bottom">
                      <Form.Label>{this.context.t("form_capture_candidate_image_every")} <Attention /></Form.Label>
                      <select disabled className="form-select " onChange={(e) => {
                      this.setState({ time_save: e.target.value })
                      }} value={this.state.time_save}>
                      {(this.state.times_save && this.state.times_save.length != 0) && this.state.times_save.map((value, index) => (
                      <option
                      key={index}
                      value={value["id"]}
                      >{translateOption(this.context.t, imageIntervalOptionKeys, value)}</option>
                      ))}
                      </select>
                      </div>
                      </InputGroup>} */}


                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("form_block_multiple_extended_screens")} <Attention /></Form.Label>

                                                <RadioGroup aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group" value={this.state.screen_extended_retrict} onChange={(e) => {// this.setState({ screen_extended_retrict: e.target.value });
                                                }}>
                                                    <FormControlLabel onClick={(e) => { if (this.state.screen_sharing == true) { return; } this.setState({ screen_extended_retrict: true }); }} disabled={this.state.screen_sharing == true} control={<Radio checked={this.state.screen_extended_retrict == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => { if (this.state.screen_sharing == true) { return; } this.setState({ screen_extended_retrict: false }); }} disabled={this.state.screen_sharing == true} control={<Radio checked={this.state.screen_extended_retrict == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>



                                            </div>
                                        </InputGroup>

                                        {this.state.fiscalizacao == 'all' && this.state.mobile == false && <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t(this.state.simulado == true ? "form_share_screen_simulation" : "form_record_candidate_screen")} <Attention /></Form.Label>
                                                <RadioGroup aria-labelledby="demo-radio-buttons-group-label" name="radio-buttons-group" value={this.state.screen_sharing} onChange={(e) => {


                                                    // this.setState({ screen_sharing: e.target.value });
                                                }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        if (this.state.mobile == true) { return; }
                                                        this.setState({ screen_sharing: true, screen_extended_retrict: true });
                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.screen_sharing == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        if (this.state.mobile == true) {
                                                            return;
                                                        }
                                                        this.setState({ screen_sharing: false });

                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.screen_sharing == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>
                                            </div>

                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("form_face_microphone_entry_question")} <Attention /></Form.Label>
                                                <small>{this.context.t("ui_se_habilitada_o_candidato_so_conseguira_acessar_a__104a32e1")}</small>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.face_validation}
                                                    onChange={(e) => {



                                                        // this.setState({ screen_sharing: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        if (this.state.mobile == true) { return; }
                                                        this.setState({ face_validation: true });
                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.face_validation == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        if (this.state.mobile == true) {
                                                            return;
                                                        }
                                                        this.setState({ face_validation: false });

                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.face_validation == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>
                                            </div>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("question_document_validation_on_entry")} <Attention /></Form.Label>
                                                <small>{this.context.t("description_document_validation_on_entry")}</small>
                                                <RadioGroup aria-labelledby="document-validation-radio-group" name="document-validation-radio-group" value={this.state.show_document}>
                                                    <FormControlLabel onClick={() => this.setState({ show_document: true })} control={<Radio checked={this.state.show_document == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={() => this.setState({ show_document: false })} control={<Radio checked={this.state.show_document == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                                </RadioGroup>
                                            </div>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("form_required_external_camera")} <Attention /></Form.Label>
                                                <small>{this.context.t("description_required_external_camera")}</small>
                                                <RadioGroup aria-labelledby="required-external-camera-radio-group" name="required-external-camera-radio-group" value={this.state.required_external_camera}>
                                                    <FormControlLabel onClick={() => this.setState({ required_external_camera: true })} disabled={this.state.mobile} control={<Radio checked={this.state.required_external_camera == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={() => this.setState({ required_external_camera: false })} disabled={this.state.mobile} control={<Radio checked={this.state.required_external_camera == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                                </RadioGroup>
                                            </div>
                                            {this.state.simulado == false && <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("form_record_before_exam_question")} <Attention /></Form.Label>
                                                <small>{this.context.t("description_record_before_exam")}</small>
                                                <RadioGroup aria-labelledby="record-before-exam-radio-group" name="record-before-exam-radio-group" value={this.state.recording_start_before_enabled}>
                                                    <FormControlLabel onClick={() => this.setState({ recording_start_before_enabled: true, recording_start_before_minutes: this.state.recording_start_before_minutes || 5 })} control={<Radio checked={this.state.recording_start_before_enabled == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={() => this.setState({ recording_start_before_enabled: false, recording_start_before_minutes: 5 })} control={<Radio checked={this.state.recording_start_before_enabled == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />
                                                </RadioGroup>
                                            </div>}
                                            {this.state.simulado == false && this.state.recording_start_before_enabled == true && <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("form_record_before_exam_minutes")} <Attention /></Form.Label>
                                                <Input
                                                    placeholder={this.context.t("form_record_before_exam_minutes")}
                                                    value={this.state.recording_start_before_minutes}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        this.setState({ recording_start_before_minutes: value === '' ? '' : Math.min(30, Math.max(1, parseInt(value, 10) || 1)) });
                                                    }}
                                                    min={1}
                                                    max={30}
                                                    required
                                                    type='number'
                                                />
                                            </div>}
                                        </InputGroup>}
                                        {this.state.fiscalizacao == 'all' && this.state.mobile == false && <InputGroup>

                                            {this.state.face_validation && <div className="margin-bottom">
                                                <>

                                                    <Form.Label>{this.context.t("ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_018422a2")}<Attention /></Form.Label>
                                                    <br />

                                                    <small>{this.context.t("ui_exemplo_caso_seja_colocado_60_minutos_entao_uma_ho_333a557f")}</small>

                                                    <Input
                                                        placeholder={this.context.t("ui_tempo_em_minuntos_anterior_a_avaliacao_que_deve_ap_018422a2")}
                                                        value={this.state.request_time}
                                                        onChange={(e) => this.setState({ request_time: e.target.value })}
                                                        required
                                                        min={1}

                                                        type='number'
                                                    // title="Coloque o nome completo do usuário"
                                                    />
                                                </>
                                            </div>}
                                            {this.state.face_validation == true && <div className="margin-bottom" style={{ marginLeft: 0, marginRight: 0, paddingLeft: 0, paddingRight: 0 }}>
                                                <Form.Label>{this.context.t("form_face_microphone_periodic_question")} <Attention /></Form.Label>
                                                <br />

                                                <small>{this.context.t("ui_se_habilitada_caso_apos_o_candidato_acessar_a_aval_76209b26")}</small>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.face_validation_periodicaly}
                                                    onChange={(e) => {



                                                        // this.setState({ screen_sharing: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        if (this.state.mobile == true) { return; }
                                                        this.setState({ face_validation_periodicaly: true });
                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.face_validation_periodicaly == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        if (this.state.mobile == true) {
                                                            return;
                                                        }
                                                        this.setState({ face_validation_periodicaly: false });

                                                    }} disabled={this.state.mobile} control={<Radio checked={this.state.face_validation_periodicaly == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>
                                                {this.state.face_validation_periodicaly && <>
                                                    <Form.Label>{this.context.t("ui_tempo_sem_reconhecimento_para_o_candidato_ter_que__36fb327b")}<Attention /></Form.Label>
                                                    <Input
                                                        placeholder={this.context.t("ui_tempo_sem_reconhecimento_para_o_candidato_ter_que__36fb327b")}
                                                        value={this.state.time_validation_periodicaly}
                                                        onChange={(e) => this.setState({ time_validation_periodicaly: e.target.value })}
                                                        required
                                                        min={20}
                                                        type='number'
                                                    // title="Coloque o nome completo do usuário"
                                                    />
                                                </>}
                                            </div>}
                                        </InputGroup>}

                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_restringir_horario_de_acesso_do_candidato_ff671aed")}<Attention /></Form.Label>
                                                <small>{this.context.t("ui_candidatos_que_nao_tiverem_acessado_o_sistema_dent_db3aa123")}</small>
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.restrict_access}
                                                    onChange={(e) => {
                                                        this.setState({ restrict_access: e.target.value });
                                                    }}>

                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ restrict_access: true });
                                                    }} control={<Radio checked={this.state.restrict_access == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={(e) => {
                                                        this.setState({ restrict_access: false });

                                                    }} control={<Radio checked={this.state.restrict_access == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>
                                            </div>
                                        </InputGroup>

                                        {this.state.restrict_access == true && <MuiPickersUtilsProvider utils={MomentUtils}>

                                            <InputGroup>

                                                <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                    <Form.Label>{this.context.t("form_access_interval_start_date")} <Attention /></Form.Label>
                                                    <DatePicker
                                                        autoOk
                                                        margin="normal"
                                                        style={{ width: '100%' }}
                                                        invalidDateMessage={this.context.t("ui_data_invalida_76fc5825")}
                                                        ampm={false}
                                                        id="time-picker"
                                                        cancelLabel={this.context.t("legacy_cancelar")}
                                                        clearLabel={this.context.t("action_clear")}
                                                        format="DD/MM/YYYY"
                                                        value={this.state.inicio_access}
                                                        onChange={(date) => { this.setState({ inicio_access: date }); }} />


                                                </div>
                                                <div className="flex fdcolumn flex1 margin-bottom">
                                                    <Form.Label>{this.context.t("ui_horario_inicial_do_intervalo_dbb8ab8c")}<Attention /></Form.Label>
                                                    <TimePicker
                                                        autoOk
                                                        margin="normal"
                                                        style={{ width: '100%' }}
                                                        invalidDateMessage={this.context.t("ui_horario_invalido_6d7a8390")}
                                                        ampm={false}
                                                        id="time-picker"
                                                        cancelLabel={this.context.t("legacy_cancelar")}
                                                        clearLabel={this.context.t("action_clear")}
                                                        label=""
                                                        value={this.state.hora_inicio_access}
                                                        onChange={(date) => { this.setState({ hora_inicio_access: date }); }} />


                                                </div>
                                            </InputGroup>

                                            <InputGroup>

                                                <div className="flex fdcolumn flex1 margin-bottom me-3">
                                                    <Form.Label>{this.context.t("ui_data_de_encerramento_do_intervalo_ca148297")}<Attention /></Form.Label>
                                                    <DatePicker
                                                        autoOk
                                                        margin="normal"
                                                        style={{ width: '100%' }}
                                                        invalidDateMessage={this.context.t("ui_data_invalida_76fc5825")}
                                                        ampm={false}
                                                        id="time-picker"
                                                        cancelLabel={this.context.t("legacy_cancelar")}
                                                        clearLabel={this.context.t("action_clear")}
                                                        format="DD/MM/YYYY"
                                                        value={this.state.fim_access}
                                                        onChange={(date) => { this.setState({ fim_access: date }); }} />


                                                </div>
                                                <div className="flex fdcolumn flex1 margin-bottom">
                                                    <Form.Label>{`${this.context.t("legacy_horario_de_encerramento_do_intervalo")} `}<Attention /></Form.Label>
                                                    <TimePicker
                                                        autoOk
                                                        margin="normal"
                                                        style={{ width: '100%' }}
                                                        invalidDateMessage={this.context.t("ui_horario_invalido_6d7a8390")}
                                                        ampm={false}
                                                        id="time-picker"
                                                        cancelLabel={this.context.t("legacy_cancelar")}
                                                        clearLabel={this.context.t("action_clear")}
                                                        label=""
                                                        value={this.state.hora_fim_access}
                                                        onChange={(date) => { this.setState({ hora_fim_access: date }); }} />


                                                </div>
                                            </InputGroup>



                                        </MuiPickersUtilsProvider>}

                                        <InputGroup>
                                            <div className="flex fdcolumn flex1 margin-bottom">
                                                <Form.Label>{this.context.t("ui_o_evento_sera_dividido_em_blocos_d2406ebe")}<Attention /></Form.Label>
                                                <small>{this.context.t("ui_caso_sim_e_possivel_definir_o_tempo_de_cada_bloco__e1f7d3b8")}</small>
                                                {/* {this.state.simulado && <small>{this.context.t("description_simulation_without_blocks")}</small>} */}
                                                <RadioGroup
                                                    aria-labelledby="demo-radio-buttons-group-label"
                                                    name="radio-buttons-group"
                                                    value={this.state.has_blocks}
                                                    onChange={(e) => {
                                                        if (this.state.simulado) return;
                                                        const hasBlocks = e.target.value == true || e.target.value === 'true';
                                                        this.setState({ has_blocks: hasBlocks, ...(hasBlocks ? { type_time: 'all', tempo_prova: '' } : {}) });
                                                    }}>

                                                    <FormControlLabel onClick={() => {
                                                        if (this.state.simulado) return;
                                                        this.setState({ has_blocks: true, type_time: 'all', tempo_prova: '' });
                                                    }} disabled={this.state.simulado} control={<Radio checked={this.state.has_blocks == true} value={true} />} style={{ color: 'black' }} label={this.context.t("answer_yes")} />
                                                    <FormControlLabel onClick={() => this.setState({ has_blocks: false })} disabled={this.state.simulado} control={<Radio checked={this.state.has_blocks == false} value={false} />} style={{ color: 'black' }} label={this.context.t("answer_no")} />

                                                </RadioGroup>
                                            </div>
                                        </InputGroup>

                                    </>}
                                    {this.state.loading_save == false && <div className="w100 inline-flex jcsb margin-top-1">
                                        {/* <Link to={`/accounts/list`}>
                      <Button variant="secondary"><RiArrowGoBackLine/> Voltar</Button>
                      </Link> */}
                                        <DefaultButton
                                            bg="secondary"
                                            text={this.context.t("back")}
                                            icon={<RiArrowGoBackLine />}
                                            to={`/instituicao/show/${this.state.faculdade.id}`} />

                                        {/* <Button variant="success" type="submit" disabled={this.loading}>
                      {this.state.loading ? <Spinner /> : ""}
                      Registrar usuário
                      </Button> */}
                                        <DefaultButton
                                            type="submit"
                                            bg="confirm"
                                            text={`${this.context.t("action_save")} ${this.context.t(this.props.user.empresa == null || this.props.user.empresa.change_text == false ? "entity_process" : "entity_vacancy_position")}`}
                                            disabled={this.state.loading_image == true}
                                            loadingtext={`${this.context.t("action_saving")} ${this.context.t(this.props.user.empresa == null || this.props.user.empresa.change_text == false ? "entity_process" : "entity_vacancy_position")}`}
                                            loading={this.state.loading_save} />

                                    </div>}

                                    {this.state.loading_save == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center margin-top-1">
                                        <div className="spinner-border text-primary" role="status">
                                        </div>
                                    </div></div>}
                                </Form>

                            </div>}

                            {this.state.loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                                <div className="spinner-border text-primary" role="status">
                                </div>
                            </div></div>}


                        </div>

                    </div>
                </div>

                {this.state.loading_screen == false &&<div className="col-12 col-xl-4 process-summary-column">
                    <ProcessoConfigSummary state={this.state} user={this.props.user} />
                </div>}
            </div>);

    }


}
const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        user: state.AppReducer.user
    });


export default connect(mapsStateToProps, { logout })(EditarProcesso);
